import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { DialogActions } from '@mui/material'
import React from 'react'

import { useDeleteServiceMutation } from 'shared/store/useAddtionalServices'
import ContainedButton from 'shared/components/Buttons/ContainedButton'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'
import CustomDialog from 'shared/components/CustomDialog'

import { ModalInfoType } from '../types'
import CreateServiceModal from './components/CreateServiceModal'
import EditServiceModal from './components/EditServiceModal'

interface Props {
   handleClose: () => void
   modalInfo?: ModalInfoType
}

export default function Modal({ handleClose, modalInfo }: Props) {
   const { t } = useTranslation(['SERVICES', 'TRANSLATION'])
   const { mutate, isLoading } = useDeleteServiceMutation()

   function removeService() {
      if (modalInfo?.locationUuid && modalInfo.serviceUuid) {
         mutate(
            { locationUuid: modalInfo.locationUuid, serviceUuid: modalInfo.serviceUuid },
            {
               onSuccess: () => {
                  handleClose()
               },
            }
         )
      }
   }

   function renderContent() {
      switch (modalInfo?.modalType) {
         case 'DELETE':
            return (
               <>
                  <DialogContent>
                     <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                        {t('SERVICES:deleteSureText', {
                           serviceName: `${modalInfo?.serviceName}`,
                        })}
                     </Typography>
                  </DialogContent>
                  <DialogActions>
                     <OutlinedButton isDelete variant="outlined" onClick={handleClose}>
                        {t('TRANSLATION:no')}
                     </OutlinedButton>
                     <ContainedButton isDelete variant="contained" disabled={isLoading} onClick={() => removeService()}>
                        {t('TRANSLATION:yes')}
                     </ContainedButton>
                  </DialogActions>
               </>
            )
         case 'EDIT':
            return (
               <EditServiceModal
                  serviceUuid={modalInfo.serviceUuid || ''}
                  locationUuid={modalInfo.locationUuid}
                  handleClose={handleClose}
                  serviceInfo={modalInfo.serviceInfo}
               />
            )
         case 'CREATE':
            return <CreateServiceModal locationUuid={modalInfo.locationUuid} handleClose={handleClose} />
         default:
            return null
      }
   }
   return (
      <CustomDialog
         open={!!modalInfo?.modalType}
         onClose={handleClose}
         deleteVariant={modalInfo?.modalType === 'DELETE'}
         isLoading={!modalInfo}
         content={
            <>
               <DialogTitle>{t(`${modalInfo?.modalType?.toLowerCase()}`)}</DialogTitle>
               {renderContent()}
            </>
         }
      />
   )
}
